import './LookaheadOtherGroup.css';
import LookaheadOtherGroup from './LookaheadOtherGroup';

export default LookaheadOtherGroup;
